<template>
  <div id="app">
    <div
      v-if="isUpgradeOffer"
      class="bg-black py-3 md:flex md:justify-center md:items-center px-4"
    >
      <h6 class="text-accent-light font-bold mr-2 text-sm md:text-lg">
        SPECIAL UPGRADE OFFER - SAVE $20
      </h6>
      <h6 class="text-white mr-2 text-sm md:text-lg">
        This conference is included with All Access and Virtual Access Subscriptions.
      </h6>
      <nuxt-link to="/subscription/subscription-v2">
        <h6 class="text-accent-light font-bold text-sm md:text-lg">
          Claim your upgrade savings!
        </h6>
      </nuxt-link>
    </div>
    <nav-bar />
    <Nuxt />
    <nav-footer-info />
  </div>
</template>

<script>
import { mapActions, } from 'pinia';
import { useCartStore, } from '../stores/cart';

export default {
  name: 'VirtualConference',
  setup() {
    const { $auth: auth } = useNuxtApp();
    return auth;
  },
  head() {
    return {
      script: [
        {
          hid: 'trustpilot',
          src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
          defer: true,
          // Changed after script load
        },
      ],
    };
  },
  computed: {
    isUpgradeOffer() {
      if (this.auth.loggedIn.value) {
        if (this.auth.user.value.subscription_type.includes('core100') || this.auth.user.value.subscription_type.includes('subonline')) {
          return true;
        }
        else {
          return false;
        }
      }
      else if (this.$route.query.upgradeoffer === '1') {
        return true;
      }
      else {
        return false;
      }
    },
  },
  mounted() {
    this.initializeCart();
  },
  methods: {
    ...mapActions(useCartStore, ['initializeCart']),
  },
};
</script>

<style scoped>
#app {
  font-family: Lato, sans-serif;
}
</style>
